import { FC, useEffect, useState } from "react";
import { useMediaQuery } from "context/media/MediaContext";

import { StyledHeader } from "./Header.styles";
import { Container } from "components";

import { useAppSelector } from "redux/hooks";
import useOtp from "helpers/hooks/useOtp";
import MobileHeader from "./MobileHeader";
import DesktopHeader from "./DesktopHeader";

const Header: FC = () => {
  const { isMobile } = useMediaQuery();
  const isOtp = useOtp();

  const { isLoggedIn } = useAppSelector((state) => state.login);
  const [loginScreen, setLoginScreen] = useState(isLoggedIn);

  useEffect(() => {
    if (isOtp) setLoginScreen(isLoggedIn);

    if (!isLoggedIn) setLoginScreen(false);
  }, [isLoggedIn, isOtp]);

  const ContainerFragment: FC<{ children: React.ReactNode }> = ({
    children,
  }): JSX.Element =>
    isLoggedIn ? <>{children}</> : <Container>{children}</Container>;

  return (
    <StyledHeader>
      <ContainerFragment>
        {isMobile ? (
          <MobileHeader loginScreen={loginScreen} />
        ) : (
          <DesktopHeader loginScreen={loginScreen} />
        )}
      </ContainerFragment>
    </StyledHeader>
  );
};

export default Header;
